import _ from "lodash";
import { Menu, Radio, RadioChangeEvent, Space } from 'antd';
import FavLists from "./favList";
import { CallLists } from "./CallLists";
import RecordedLists from "./recordedList";
import VoiceMailLists from "./voicemailList";
import store from "../../../context/store/store";
import React, { useEffect, useState } from "react";
import styles from "./scss/leftsidebar.module.scss";
import { URInput } from "../../../shared/widgets/input";
import { contactService } from "../../../base/contactService";
import CreateDropDown from "../../chat/leftsidebar/createdropdown";
import { closePrfWindow, modifyLogsInput, storeLogs, switchComponent } from "../../../base/callService/store_mining";
import { getCallLogsCDR, getGroupLogUsers, getRecordingLogs, getVoiceMailLogs } from "../../../base/callService/callsApiService";
import { filterFavouriteCalls, initiateAPICall } from "../../../base/callService/common";
import NotificationBottom from "../../chat/chatWidgets/notificationBottom";
import { enablePermission, enablePermissionSafari } from "../../../base/utils";
import { chats, initialStateModel } from "../../../models/model";
import { useSelector } from "react-redux";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import favList from "./favList";
import CreatePrivateGroup from "../../contacts/leftsidebar/CreateNewGroup/privategroupindex";
import { chatTeamValidation } from "../../../base/socketChatService/utils";
const { SubMenu } = Menu;
export default function LeftsideBars() {

  let { logsInput, totalRecordings, totalVoicemails }: any = store.getState().callReducer || [];
  let { leftSideWindow } = store.getState().updatedCallList;
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
  const { callReducer }: initialStateModel = useSelector((state: initialStateModel) => state);
  const [groupLogUsers, setGroupLogUsers] = useState({});
  const [displayGroup, setDisplayGroup] = useState(false);
  const [callRecordingBtnDisable, setCallRecordingBtnDisable] = useState(false);
  let favList = filterFavouriteCalls(callReducer.logs);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  //const chat_reducer: chats = store.getState().chatReducer;
  //let allContacs:any = store.getState().contactReducer;
  chat_reducer.isWindowSlide && chatSideWindow(false, "", {});
  const chooseListOption = (type: string) => {
    closePrfWindow();
    let { logsInput } = store.getState().callReducer || {};
    switchComponent(type);
    modifyLogsInput(logsInput.search, type === 'callList' ? 1 : 0);
    initiateAPICall();
  };


  useEffect(() => {
    contactService.rec_voicemailCount();
    modifyLogsInput('', 1);
    chooseListOption('callList');
  }, []);

  const shareSearch = _.debounce(async (e: any) => {
    storeLogs([]);
    if (leftSideWindow === "voiceMail") { getVoiceMailLogs(0, e) }
    else if (leftSideWindow === "callList") { getCallLogsCDR(1, logsInput.filter, e); }
    else if (leftSideWindow === "recordList") { getRecordingLogs(0, e); }

  }, 500);

  useEffect(() => {
    if (navigator.userAgent.indexOf("Safari") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1) {
      enablePermissionSafari('calls');
    }
    else {
      enablePermission('calls');
    }
  }, []);

  useEffect(() => {
    // {Call Log Leftside Recording}
    const CallRecording = planBased.find((item:any) => item.featureid === 50);
    if (CallRecording && CallRecording.value1 === "Yes") {
      setCallRecordingBtnDisable(false); 
    } else {
      setCallRecordingBtnDisable(true); 
    }
  }, [planBased]); 

  const showGroupModal = (status: boolean) => {
    setDisplayGroup(status);

    chatTeamValidation(status);
  };

  const openGroup = async (particularGroupDetail: any, status: boolean) => {
    let userObj: any = {};
    let groupUsers: any = await getGroupLogUsers(particularGroupDetail?.groupId)
    userObj.users = groupUsers
    userObj.groupName = particularGroupDetail.callerId ? particularGroupDetail.callerId : particularGroupDetail.caller_id;
    userObj.groupId = particularGroupDetail?.groupId
    setGroupLogUsers(userObj)
    setTimeout(() => {
      setDisplayGroup(status);

    }, 500);

  }

  return (
    <>
      <div className={styles.leftsidebar}>
        <div className={styles.top}>
          <CreateDropDown></CreateDropDown>
        </div>
        {/* {(!chat_reducer.notifyPermission || !chat_reducer.audioPermission || !chat_reducer.videoPermission) && <div className={styles.notificationtop}><NotificationBottom  /></div>} */}
        {(!chat_reducer.notifyPermission) && <div className={styles.notificationtop}><NotificationBottom /></div>}
        <Space className="callTabSec" defaultValue='calls' defaultChecked={true}>
          <Radio.Group value={leftSideWindow}>
            <Radio.Button value="callList" onClick={() => chooseListOption('callList')}>Calls</Radio.Button>
            <Radio.Button value="voiceMail" onClick={() => chooseListOption('voiceMail')}>Voicemail</Radio.Button>
            <Radio.Button className={callRecordingBtnDisable ? 'disabledIcon':''} value="recordList" onClick={() => chooseListOption('recordList')}>Recorded</Radio.Button>
          </Radio.Group>
        </Space> 
        <div className={styles.middlelayertop}>
          <URInput placeHolder="Search" className="leftbarsearch"
            onChange={((e: any) => shareSearch(e.target.value))} />
        </div>
        {/* {leftSideWindow === "callList" ? <ul className={styles.quickLinks}>
          {totalVoicemails > 0 && <li className={`callfadein ${styles.quickLinksvoice}`} onClick={() => chooseListOption('voiceMail')}>
            <span className="icon_Recordcalls"></span>Voicemail
            <span className={styles.counts}>{totalVoicemails}</span></li>}
          {totalRecordings > 0 && <li className="callfadein" onClick={() => chooseListOption('recordList')}>
            <span className="icon_recordoutlinefill"></span>Recorded Calls<span className={styles.counts}>
              {totalRecordings}</span></li>}
        </ul>
          : null
        } */}

        {((leftSideWindow === "callList") && (favList?.length > 0)) && <Menu
          defaultSelectedKeys={['1']} mode="inline" className="favList">
          <SubMenu key="sub2" title="Favourites" icon={<span className='icon_starfill' />}>
            <FavLists></FavLists>
          </SubMenu>
        </Menu>}

        <div className={`${styles.scrolllayerleft} `}>
          <div className={styles.middlelayermiddle}>
            {leftSideWindow === "callList" &&
              <CallLists openGroup={openGroup} />}
            {leftSideWindow === "voiceMail" &&
              <VoiceMailLists backEventTrigger={chooseListOption} ></VoiceMailLists>}
            {leftSideWindow === "recordList" &&
              <RecordedLists backEventTrigger={chooseListOption}></RecordedLists>}
          </div>
        </div>

        {/* <CreatePrivateGroup fromCallLog={true} groupLogUsers={groupLogUsers} showGroupmodel={showGroupModal} isModel={displayGroup} /> */}
      </div>
    </>
  );
};

